module.exports = __webpack_public_path__ + "static/media/hand_lettered_layout_for_vintage_delivery_truck.1f45e8b8.webp";